var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{staticClass:"header-home"}),_c('SliderNew3D'),_c('TopCompany'),_c('TopInvestor'),_c('TopFreelancer'),_c('FooterSlider'),_c('NewBlog'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }